/**
 * A compact sample of the most frequently leaked passwords (compiled from public breach
 * corpora). Real products should check against a much larger list or a k-anonymity API
 * such as Have I Been Pwned; this list keeps the demo dependency-free.
 */
export const COMMON_PASSWORDS: ReadonlySet<string> = new Set([
  '000000',
  '111111',
  '112233',
  '121212',
  '123123',
  '123321',
  '1234',
  '12345',
  '123456',
  '1234567',
  '12345678',
  '123456789',
  '1234567890',
  '123qwe',
  '131313',
  '159753',
  '1q2w3e4r',
  '1qaz2wsx',
  '555555',
  '654321',
  '666666',
  '696969',
  '7777777',
  '987654321',
  'aaaaaa',
  'abc123',
  'access',
  'admin',
  'administrator',
  'amanda',
  'andrew',
  'asdfgh',
  'asdfghjkl',
  'ashley',
  'austin',
  'baseball',
  'batman',
  'biteme',
  'buster',
  'charlie',
  'cheese',
  'chelsea',
  'computer',
  'dallas',
  'daniel',
  'dragon',
  'football',
  'freedom',
  'george',
  'ginger',
  'hannah',
  'harley',
  'hello',
  'hockey',
  'hunter',
  'iloveyou',
  'jennifer',
  'jessica',
  'jordan',
  'joshua',
  'killer',
  'letmein',
  'login',
  'love',
  'maggie',
  'master',
  'matrix',
  'matthew',
  'michael',
  'michelle',
  'monkey',
  'mustang',
  'nicole',
  'passw0rd',
  'password',
  'password1',
  'password123',
  'pepper',
  'princess',
  'qazwsx',
  'qwerty',
  'qwerty123',
  'qwertyuiop',
  'ranger',
  'robert',
  'secret',
  'shadow',
  'soccer',
  'starwars',
  'summer',
  'sunshine',
  'superman',
  'taylor',
  'thomas',
  'thunder',
  'tigger',
  'trustno1',
  'welcome',
  'whatever',
  'yankees',
  'zxcvbn',
  'zxcvbnm',
]);
